const Console = () => import('@/vuepage/common-manage/Console');
export default [{
		path: '/Console',
		component: Console,
		meta: [{
				name: '工作台'
			},
			{
				name: '工作台',
				activeRoute: '/console'
			}
		]
	}
];